import { RemoteResult, BenutzerRegistrierenRequest, LoadState } from "mangdto"
import vuexStore from "@/store"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import { Validator } from "mangutil"

export default class RegistrierenLogic {
  nachname?: string = null
  vorname?: string = null
  benutzername?: string = null
  passwort?: string = null
  passwortWiederholen?: string = null
  showPasswort: boolean = false
  agbsAkzeptiert: boolean = false

  registrierenLoadState: LoadState = LoadState.Idle
  registrierenFormDisabled: boolean = false

  emailRules = Validator.emailValidate
  passwortRules = Validator.strongPasswordRules
  nachnameRules = [(v) => !!v || "Bitte Nachname angeben"]
  vornameRules = [(v) => !!v || "Bitte Vorname angeben"]

  registrieren() {
    this.registrierenFormDisabled = true
    this.registrierenLoadState = LoadState.Loading

    var request = new BenutzerRegistrierenRequest()
    request.nachname = this.nachname
    request.vorname = this.vorname
    request.benutzername = this.benutzername
    request.passwort = this.passwort
    request.identifier = vuexStore.state.user.identifier

    Poster.postUser<RemoteResult<any>>(
      RestPaths.kundeBenutzerRegistrieren,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.registrierenLoadState = LoadState.Completed
        } else {
          this.registrierenLoadState = LoadState.Error
          this.registrierenFormDisabled = false
        }
      })
      .catch(() => {
        this.registrierenLoadState = LoadState.Error
        this.registrierenFormDisabled = false
      })
  }
}
